module.exports = __webpack_public_path__ + "img/semipublic.7465f811.svg";